import { Link } from 'react-router-dom';

import { PAGE_CONTAINER_CLASS } from '@/components/shell/AdminPageHeader';
import { LoadError } from '@/components/ui/load-state';

/** A detail page whose record failed to load: the error with a Retry, and a way back to its list. */
export function AdminPageLoadError({
  message,
  onRetry,
  backTo,
  backLabel,
}: {
  message?: string;
  onRetry: () => void;
  backTo: string;
  backLabel: string;
}) {
  return (
    <div className={PAGE_CONTAINER_CLASS}>
      <div className="space-y-3">
        <LoadError message={message} onRetry={onRetry} className="rounded-xl border border-border bg-card" />
        <Link to={backTo} className="text-sm text-primary hover:underline">
          {backLabel}
        </Link>
      </div>
    </div>
  );
}
